import React from "react";
import { useTranslation } from "react-i18next";
import PolicyBackButton from "./policyBackButton";
import useUrlLanguage from "../i18n/useUrlLanguage";

const AccessibilityStatement = () => {
  const { t, i18n } = useTranslation();
  useUrlLanguage();

  const switchLang = async (e) => {
    const lang = e.target.value;
    localStorage.setItem("userLanguage", lang);
    const { loadLanguage } = await import("../i18n/i18n");
    await loadLanguage(lang);
    i18n.changeLanguage(lang);
  };

  return (
    <div>
      <div className="fixed-top stripe py-3 border-bottom heading-wrapper">
        <div className="d-flex align-items-center justify-content-center px-3">
          {/* <PolicyBackButton /> */}
          <p className="fw-bold text-center terms-page-heading mb-0 flex-grow-1">
            {/* {t("common.terms.heading")} */}
            {t("common.accessibility.heading")}
          </p>
          {/* <select
            className="policy-language-select"
            value={i18n.language}
            onChange={switchLang}
            style={{
              padding: "4px 8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "13px",
            }}
          >
            <option value="cy">Cymraeg</option>
            <option value="gd">Gàidhlig</option>
            <option value="en">English</option>
            <option value="ar">العربية</option>
            <option value="bn">বাংলা</option>
            <option value="es">Español</option>
            <option value="fr">Français</option>
            <option value="gu">ગુજરાતી</option>
            <option value="pa">ਪੰਜਾਬੀ</option>
            <option value="pl">Polski</option>
            <option value="pt">Português</option>
            <option value="ro">Română</option>
            <option value="so">Soomaali</option>
            <option value="tr">Türkçe</option>
            <option value="ur">اردو</option>
          </select> */}
        </div>
      </div>
      <div
        className="mx-3 text-justify terms px-3 terms-text"
        dangerouslySetInnerHTML={{
          __html: t("common.accessibility.bodyHtml"),
        }}
      />
      <style jsx>{`
      th {
    display: table-cell;
    vertical-align: inherit;
    font-weight: bold;
    text-align: -internal-center;
    unicode-bidi: isolate;
    text-align:center;
        border: 2px solid;
}
    .th, td {
        border-style: solid;
        text-align: center;
    }
        table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #000000;
        }
            tr {
            height: 40px;
        }

        td {
            border: 1px solid #000000;
            padding: 8px 12px;
            font-size: 16px;
            vertical-align: middle;
            text-align: left;
        }
            td:first-child {
            font-weight: bold;
            width: 50%;
        }

        a {
            color: #0000EE;
            text-decoration: underline;
        }

        a:hover {
            color: #0000AA;
        }
            .footer-text {
            text-align: right;
            font-size: 14px;
            margin-top: 8px;
            color: #000000;
        }
    @media (max-width: 768px) {
        .terms-page-heading {
            text-align: left !important;
            font-size: clamp(10px, 4vw, 14px) !important;
            white-space: nowrap;
        }
    }
`}</style>
    </div>
  );
};

export default AccessibilityStatement;
